import { z } from 'zod/v4';

export const countryCodeSettingsSchema = z.object({
  countryName: z.string().optional(),
  countryCode: z.string().optional(),
  dialCode: z.string().optional(),
  enabled: z.boolean(),
});

export type CountryCodeSettings = z.infer<typeof countryCodeSettingsSchema>;
